import apiClient from "../../utils/apiClient"; // Adjust path based on your structure
const APIKEY = process.env.REACT_APP_INTERNAL_API_KEY

export const fetchproduct = (data) => {
  return apiClient.get(`/products/products/location`, {
    headers: {
      'x-api-key': APIKEY
    },
    params: data
  });
}


export const productDetails = (productuuid) => {
  return apiClient.get(`/products/products/details/${productuuid}`, {
    headers: {
      'x-api-key': APIKEY
    },
  });
}

export const productSearch = (searchTerm) => {
  return apiClient.get(`/products/products/suggestions`, {
    headers: {  
      'x-api-key': APIKEY
    },
    params: { query: searchTerm }
  });
}

// In your Product.js service file
export const MultipleVendorforProduct = (productUuid, postalCode, page = 1, limit = 20) => {
  return apiClient.get(`/products/products/vendors`, {
    headers: {  
      'x-api-key': APIKEY
    },
    params: { 
      productUuid: productUuid,
      postalCode: postalCode,
      page: page,
      limit: limit
    }
  });
}